module.exports = __webpack_public_path__ + "media/images/pla/pla21-bb1d5d62731e0ceca267a3d7cd632c60.jpg";